import { I18n } from "@assets/strings";
import { useLocation } from "react-router";
import { useHistory } from "@core/routing/useHistory";
import { Environment } from "@core/config/environment";
import { Path, searchParams } from "@core/routing/path";

interface UseTopBarNavigationOptions {
	onAfterNavigate?: () => void;
}

export interface TopBarNavigation {
	goToHome: () => void;
	goToSearch: () => void;
	isHomeSelected: boolean;
	isSearchSelected: boolean;
	isJaangal: boolean;
	homeLabel: string;
	homeTooltip: string;
	exploreLabel: string;
	searchLabel: string;
	messagesLabel: string;
}

export function useTopBarNavigation(options?: UseTopBarNavigationOptions): TopBarNavigation {
	const history = useHistory();
	const location = useLocation();
	const { onAfterNavigate } = options ?? {};

	const runNavigation = (action: () => void): void => {
		action();
		if (typeof onAfterNavigate === "function") {
			onAfterNavigate();
		}
	};

	const goToHome = (): void => {
		runNavigation(() => {
			window.scrollTo({ top: 0, behavior: "smooth" });
			history.push({ pathname: Path.Root, search: searchParams("") });
		});
	};

	const goToSearch = (): void => {
		runNavigation(() => {
			history.push({ pathname: Path.Search, search: searchParams("") });
		});
	};

	const isHomeSelected = location.pathname === Path.Root;
	const isSearchSelected = location.pathname === Path.Search;
	const isJaangal = Environment.APP_VARIANT === "jaangal";

	return {
		goToHome,
		goToSearch,
		isHomeSelected,
		isSearchSelected,
		isJaangal,
		homeLabel: isJaangal ? I18n.t("feed-link") : I18n.t("tooltip.home"),
		homeTooltip: I18n.t("tooltip.home"),
		exploreLabel: I18n.t("explore"),
		searchLabel: I18n.t("search.input.placeholder"),
		messagesLabel: I18n.t("navigation.messages"),
	};
}
